import { get } from "../../service/api";

const getFAQ = async () => {
  try {
    const response = await get(`/ai/faq`);
    return response;
  } catch (error) {
    console.error("Error getFAQ:", error);
    throw error;
  }
};

export default getFAQ;
